import React, { useState } from 'react'

// components
import SideViewModal from '../../../../components/modals/SideViewModal/SideViewModal.component'

// collections
import EditPurchaseOrder from '../EditPurchaseOrder.form'

// queries
import { useMutation } from '@apollo/client'
import { EDIT_EQUIPMENT_PURCHASE_ORDER } from '../../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.mutations'
import {
  GET_PURCHASE_ORDER_BY_ID_FOR_EDIT_FORM,
  GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_INFO,
  GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_NUMBER_AND_STATUS,
  GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_ITEMS
} from '../../../../graphql/equipmentPurchaseOrder/equipmentPurchaseOrder.queries'
import { apolloClient } from '../../../../index'

// utils
import { setupPurchaseOrderFinalData } from './EditPurchaseOrder.form.controller.utils'
import { validate } from '../../../../shared/utility'
import moment from 'moment'

const validationSchema = {
  vendorName: {
    type: 'input',
    validation: {
      required: true
    }
  },
  number: {
    type: 'input',
    validation: {
      required: true
    }
  },
  orderDate: {
    type: 'date',
    validation: {
      required: true,
      isDate: true
    }
  },
  job: {
    type: 'input',
    validation: {
      isNumeric: true
    }
  },
  orderItems: {
    type: 'list',
    fields: {
      quantity: {
        type: 'input',
        validation: {
          required: true,
          isNumeric: true
        }
      },
      price: {
        type: 'input',
        validation: {
          required: true,
          isCurrency: true
        }
      }
    }
  }
}

export default function EditPurchaseOrderFormController({ id, visible, closeForm }) {
  const [isFetchingObject, setIsFetchingObject] = useState(true)
  const [purchaseOrder, setPurchaseOrder] = useState(null)
  const [editPruchaseOrder] = useMutation(EDIT_EQUIPMENT_PURCHASE_ORDER)
  const [errors, setErrors] = useState({ orderItems: [] })

  const handleSubmit = (formData) => {
    const { isValid, errors } = validate(formData, validationSchema)
    const submitData = setupPurchaseOrderFinalData(formData)

    if (isValid) {
      editPruchaseOrder({
        variables: { ...submitData },
        refetchQueries: [
          GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_INFO,
          GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_NUMBER_AND_STATUS,
          GET_EQUIPMENT_PURCHASE_ORDER_BY_ID_WITH_ITEMS
        ]
      })
        .catch(e => {
          console.error(e)
        })
        .then(result => {
          if (result) {
            setErrors({ orderItems: [] })
            closeForm()
            setIsFetchingObject(true)
          }
        })
    } else {
      setErrors(errors)
    }
  }

  if (visible && isFetchingObject) {
    apolloClient.query({
      query: GET_PURCHASE_ORDER_BY_ID_FOR_EDIT_FORM,
      variables: { id: parseInt(id, 10) }
    })
      .catch(e => {
        console.error(e)
      })
      .then(result => {
        if (result) {
          const po = result.data.equipmentPurchaseOrder
          setPurchaseOrder({
            ...po,
            job: po.job ? po.job.id : '',
            // ✅ FIXED: ensure orderDate is a string, not a moment object
            orderDate: po.orderDate
              ? moment(po.orderDate).format('YYYY-MM-DD')
              : ''
          })
          setIsFetchingObject(false)
        }
      })

    return null
  }

  if (visible && !isFetchingObject && purchaseOrder) {
    const variants = [
      {
        name: 'New Purchase Order',
        component: <EditPurchaseOrder />,
        stages: 1
      }
    ]

    return (
      <SideViewModal
        show={visible}
        submitText='Save Changes'
        onSubmit={handleSubmit}
        onClose={() => {
          setErrors({ orderItems: [] })
          closeForm()
        }}
        title='Edit Purchase Order'
        variants={variants}
        prefillData={purchaseOrder}
        errors={errors}
      />
    )
  }

  return null
}
